export class LogoutOptionsBM {
    constructor(needsToRestoreUrl: boolean) {
        this.needsToRestoreUrl = needsToRestoreUrl;
    }

    public needsToRestoreUrl: boolean;
}
